/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name…" |
*
* @param {Team_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_search_placeholder = /** @type {((inputs?: Team_Search_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Search_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek op naam…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chercher par nom…")
	return /** @type {LocalizedString} */ ("Search by name…")
});